import { Flex, Spinner, HStack, Box,WrapItem, Wrap, Icon } from "@chakra-ui/react";
import { LuBell, LuMail, LuMessageCircle, LuMessageSquare, LuPhone } from "react-icons/lu";

const SelectedChannels = ({channel_list}) => {


  const availableChannels = [
        {
            name: "Whatsapp",
            icon: LuMessageCircle,
            color: "#00a63e",
            description: "Rich messaging with media and buttons",
            id: 2,
        },
        {
            name: "SMS",
            icon: LuMessageSquare,
            color: "#155dfc",
            description: "Simple text messages",
            id: 1,
        },
        {
            name: "E-Mail",
            icon: LuMail,
            color: "#9810fa",
            description: "HTML emails with rich content",
            id: 3,
        },
        {
            name: "Push Notification",
            icon: LuBell,
            color: "#e60076",
            description: "Mobile app notifications",
            id: 6,
        },
        {
            name: "In-App Notification",
            icon: LuBell,
            color: "#4f39f6",
            description: "In-app messages and alerts",
            id: 5,
        },
        {
            name: "Voice (IVR)",
            icon: LuPhone,
            color: "#f54a00",
            description: "Automated voice calls",
            id: 4,
        },
    ];

  const filteredChannels = availableChannels.filter(channel =>
      channel_list?.includes(channel.id)
    );
  
  return (
    <Wrap spacing={4}>
        {filteredChannels.map((channel,index) => (
          <WrapItem key={index}>
            <HStack spacing={1}>
              <Icon as={channel.icon} boxSize={3} color={`${channel.color}`} />
              
            </HStack>


          </WrapItem>
        ))}
      </Wrap>
  );
};

export default SelectedChannels;
